<template>
  <div>
    <el-select :value="value" :size="size" @input="change($event)">
      <el-option v-for="item in options" v-bind:key="item.name" :label="item.name" :value="item.name" />
    </el-select>
  </div>
</template>

<script>

import { fetchTemplateList } from '../../api/supplier'
export default {
  data () {
    return {
      options: []
    }
  },
  created () {
    fetchTemplateList().then((res) => {
      console.log(res.data)
      this.options = res.data
    })
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/views/supplier/SupplierTemplateSelect.vue